import { render, staticRenderFns } from "./DocumentsRevisionTable.vue?vue&type=template&id=8249f93e&scoped=true"
import script from "./DocumentsRevisionTable.vue?vue&type=script&lang=js"
export * from "./DocumentsRevisionTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentsRevisionTable.vue?vue&type=style&index=0&id=8249f93e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8249f93e",
  null
  
)

export default component.exports